function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import { Flyout } from '@els/els-react--flyout';
import { TextInput } from '@els/els-react--text-input';
import { createEnum, generateId, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classNames from 'classnames';
import PT from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  noResults: 'No results'
});

// eslint-disable-next-line import/prefer-default-export
var FilterMatch = createEnum(['global', 'startsWith']);
var defaults = {
  className: "",
  filterResults: false,
  id: null,
  messages: DefaultMessages,
  openResultsOnUpdate: true,
  results: [],
  shouldAlwaysChooseSuggestion: true,
  suggestionsFlyoutProps: {},
  filterMatch: FilterMatch.GLOBAL
};
var Autosuggest = forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    _ref$filterResults = _ref.filterResults,
    filterResults = _ref$filterResults === void 0 ? defaults.filterResults : _ref$filterResults,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults.id : _ref$id,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? defaults.messages : _ref$messages,
    _ref$results = _ref.results,
    results = _ref$results === void 0 ? defaults.results : _ref$results,
    onChange = _ref.onChange,
    onSelectResult = _ref.onSelectResult,
    _ref$openResultsOnUpd = _ref.openResultsOnUpdate,
    openResultsOnUpdate = _ref$openResultsOnUpd === void 0 ? defaults.openResultsOnUpdate : _ref$openResultsOnUpd,
    _ref$suggestionsFlyou = _ref.suggestionsFlyoutProps,
    suggestionsFlyoutProps = _ref$suggestionsFlyou === void 0 ? defaults.suggestionsFlyoutProps : _ref$suggestionsFlyou,
    textInputProps = _ref.textInputProps,
    _ref$filterMatch = _ref.filterMatch,
    filterMatch = _ref$filterMatch === void 0 ? defaults.filterMatch : _ref$filterMatch,
    _ref$shouldAlwaysChoo = _ref.shouldAlwaysChooseSuggestion,
    shouldAlwaysChooseSuggestion = _ref$shouldAlwaysChoo === void 0 ? defaults.shouldAlwaysChooseSuggestion : _ref$shouldAlwaysChoo;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputText = _useState2[0],
    setInputText = _useState2[1];
  var _useState3 = useState(results),
    _useState4 = _slicedToArray(_useState3, 2),
    resultsForDisplay = _useState4[0],
    setResultsForDisplay = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    userHasNotTyped = _useState6[0],
    setUserHasNotTyped = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isOpen = _useState8[0],
    setIsOpen = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    activeIndex = _useState10[0],
    setActiveIndex = _useState10[1];
  var _useState11 = useState(id || generateId()),
    _useState12 = _slicedToArray(_useState11, 1),
    autosuggestId = _useState12[0];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    minimumIndex = _useState14[0],
    setMinimumIndex = _useState14[1];
  var autosuggestRef = useRef();
  useImperativeHandle(ref, function () {
    return {
      setTextInputValue: function setTextInputValue(newTextValue) {
        var newIsOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInputText(newTextValue);
        setIsOpen(newIsOpen);
      },
      setAreResultsShown: function setAreResultsShown(newIsOpen) {
        setIsOpen(newIsOpen);
      }
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useEffect(function () {
    if (!shouldAlwaysChooseSuggestion) {
      setMinimumIndex(-1);
      setActiveIndex(-1);
    }
    if (shouldAlwaysChooseSuggestion) {
      setMinimumIndex(0);
      setActiveIndex(0);
    }
  }, [shouldAlwaysChooseSuggestion]);
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var onClickOutside = function onClickOutside(event) {
    var _autosuggestRef$curre;
    if (event.type === "mousedown" && !(autosuggestRef !== null && autosuggestRef !== void 0 && (_autosuggestRef$curre = autosuggestRef.current) !== null && _autosuggestRef$curre !== void 0 && _autosuggestRef$curre.contains(event.target))) {
      hideResults();
    }
  };
  var hideResults = function hideResults() {
    document.removeEventListener("mousedown", onClickOutside);
    setActiveIndex(0);
    setIsOpen(false);
  };
  var showResults = function showResults() {
    document.addEventListener("mousedown", onClickOutside);
    if (results.length > 0) {
      setIsOpen(true);
    }
  };
  var onUp = function onUp(event) {
    event.preventDefault();
    var nextActiveIndex;
    if (activeIndex === minimumIndex) {
      nextActiveIndex = resultsForDisplay.length - 1;
    } else {
      nextActiveIndex = activeIndex - 1;
    }
    setActiveIndex(nextActiveIndex);
  };
  var onDown = function onDown(event) {
    event.preventDefault();
    if (!isOpen) {
      showResults();
      return;
    }
    var nextActiveIndex;
    if (activeIndex === resultsForDisplay.length - 1) {
      nextActiveIndex = minimumIndex;
    } else {
      nextActiveIndex = activeIndex + 1;
    }
    setActiveIndex(nextActiveIndex);
  };
  var resultClick = function resultClick(result) {
    if (!isOpen) {
      if (shouldAlwaysChooseSuggestion) {
        return;
      }
      onSelectResult(inputText);
      return;
    }
    var chosenResult = result;
    if (!result) {
      chosenResult = activeIndex === -1 ? inputText : resultsForDisplay[activeIndex];
    }
    hideResults();
    onSelectResult(chosenResult);
    setInputText(chosenResult);
  };
  var onInputKeyDown = function onInputKeyDown(event) {
    switch (event.key) {
      case "Enter":
        resultClick();
        break;
      case "ArrowUp":
        onUp(event);
        break;
      case "ArrowDown":
        onDown(event);
        break;
      case "Escape":
      case "Tab":
        hideResults();
        break;
    }
  };
  var onInputChange = function onInputChange(event) {
    var newInputText = event.target.value;
    setInputText(newInputText);
    onChange(newInputText);
    if (userHasNotTyped) {
      setUserHasNotTyped(false);
    }
    if (filterResults) setResultsForDisplay(results.filter(function (result) {
      if (filterMatch === FilterMatch.STARTS_WITH) {
        return result.toLowerCase().startsWith(newInputText.toLowerCase());
      }
      return result.toLowerCase().indexOf(newInputText.toLowerCase()) !== -1;
    }));
    setActiveIndex(minimumIndex);
    if (newInputText === "") {
      setIsOpen(false);
    } else {
      showResults();
    }
  };
  useEffect(function () {
    if (userHasNotTyped) {
      return;
    }
    if (openResultsOnUpdate && results.length > 0) {
      setIsOpen(true);
    }
    if (!filterResults) {
      setResultsForDisplay(results);
    }
  }, [results, filterResults, filterMatch, openResultsOnUpdate, userHasNotTyped]);
  var boldedResult = function boldedResult(result) {
    if (inputText === "" || inputText === void 0) return result;
    var matchIndex = result.toLowerCase().indexOf(inputText.toLowerCase());
    if (matchIndex !== -1) {
      return /* @__PURE__ */React.createElement(React.Fragment, null, result.slice(0, matchIndex), /* @__PURE__ */React.createElement("strong", null, result.slice(matchIndex, matchIndex + inputText.length)), result.slice(matchIndex + inputText.length, result.length));
    }
    if (filterMatch === FilterMatch.STARTS_WITH && matchIndex !== 0) {
      return result;
    }
    return result;
  };
  var getResultClasses = function getResultClasses(index) {
    return classNames("c-els-link", "c-els-link--navigation", "c-els-link--padded-1o2", "u-els-width-1o1", {
      "c-els-link--selected": activeIndex === index
    });
  };
  var renderResults = function renderResults() {
    return isOpen && /* @__PURE__ */React.createElement("ol", {
      role: "listbox",
      "aria-label": "Suggestions",
      id: "".concat(autosuggestId, "-panel"),
      "data-testid": "results",
      className: "autosuggest__list"
    }, filterResults && resultsForDisplay.length === 0 && /* @__PURE__ */React.createElement("li", {
      className: "u-els-margin-1o2"
    }, compiledMessages.NO_RESULTS), resultsForDisplay.map(function (result, index) {
      return (
        // Deliberately cannot keyboard navigate to list items so key event not required
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /* @__PURE__ */
        React.createElement("li", {
          key: generateId(),
          id: "".concat(autosuggestId, "-result-").concat(index),
          "data-testid": "result-item",
          role: "option",
          "aria-selected": activeIndex === index ? "true" : "false",
          onClick: function onClick() {
            return resultClick(result);
          },
          className: getResultClasses(index)
        }, /* @__PURE__ */React.createElement("span", {
          className: "c-els-link__text"
        }, boldedResult(result)))
      );
    }));
  };
  return /* @__PURE__ */React.createElement("div", {
    className: className,
    id: id,
    "data-testid": "auto-suggest",
    ref: autosuggestRef
  }, /* @__PURE__ */React.createElement(Flyout, _objectSpread({
    flyout: renderResults(),
    isControlled: true,
    isOpen: isOpen,
    placement: "bottom-start",
    theme: "minimal",
    pointerType: "primary",
    pointer: false,
    className: "c-els-flyout--display-block"
  }, suggestionsFlyoutProps), /* @__PURE__ */React.createElement(TextInput, _objectSpread(_objectSpread({}, textInputProps), {}, {
    value: inputText,
    onChange: onInputChange,
    onKeyDown: onInputKeyDown,
    role: "combobox",
    "aria-autocomplete": "list",
    "aria-activedescendant": isOpen ? "".concat(autosuggestId, "-result-").concat(activeIndex) : "",
    "aria-controls": "".concat(autosuggestId, "-panel")
  }))));
});
Autosuggest.displayName = "Autosuggest";
Autosuggest.propTypes = {
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: PT.string,
  filterMatch: PT.oneOf(FilterMatch.getAll()),
  /** Do internal filtering of the provided results */
  filterResults: PT.bool,
  id: PT.string,
  /** Messages for internationalization */
  messages: PT.object,
  /** Open the results panel when the results change */
  openResultsOnUpdate: PT.bool,
  results: PT.arrayOf(PT.string),
  /** Requires the user to select an option from the list of results. If set to false, the user may also select the text within the textInput */
  shouldAlwaysChooseSuggestion: PT.bool,
  /** Any prop supported by Flyout */
  suggestionsFlyoutProps: PT.shape(Flyout.propTypes),
  /** Any prop supported by TextInput */
  textInputProps: PT.shape(TextInput.propTypes).isRequired,
  onChange: PT.func.isRequired,
  onSelectResult: PT.func.isRequired
};
Autosuggest.requiredProps = {
  onChange: ValidPropTypes.FUNCTION,
  onSelectResult: ValidPropTypes.FUNCTION,
  textInputProps: ValidPropTypes.OBJECT,
  filterMatch: ValidPropTypes.OBJECT
};
Autosuggest.defaults = defaults;
Autosuggest.DefaultMessages = DefaultMessages;
Autosuggest.FilterMatch = FilterMatch;
var RawAutosuggest = Autosuggest;
var Autosuggest$1 = makeErrorBoundComponent(RawAutosuggest);
export { Autosuggest$1 as Autosuggest, RawAutosuggest };
